<template>
  <section class="main-layout" ref="mainLayout">
    <section class="main-layout-top" ref="topRef">
      <slot name="mainLayoutTop" />
    </section>

    <section class="main-layout-center">
      <slot name="mainLayoutCenter" />
    </section>

    <section class="main-layout-bottom" ref="bottomRef">
      <slot name="mainLayoutBottom" />
    </section>
  </section>
</template>

<script setup>
/*
    <div class="app-container">
      <MainLayout>...
        <template #mainLayoutTop>
          这里放table上面的 搜索项、统计数据等
        </template>

        <template #mainLayoutCenter>
          这里放table或者其他元素 高度100% table的话 需要去掉height或者max-height属性
          <el-table height="100%"></el-table>
        </template>

        <template #mainLayoutBottom>
        这里放table下面的 分页器等
        </template>
      </MainLayout>
    </div>
*/
import { onMounted } from 'vue';

const mainLayout = ref(null);

const setHeight = () => {
  const $el = mainLayout.value;
  $el.style.height = `calc(100vh - ${$el.getBoundingClientRect().top + 10}px)`;
};

onMounted(() => {
  setHeight();
});

const bottomRef = ref()
const topRef = ref()
// 计算内容区，最大高度
function calContentMaxHeight() {
  return mainLayout.value.clientHeight - bottomRef.value.clientHeight - topRef.value.clientHeight
}

defineExpose({
  setHeight,
  calContentMaxHeight,
});
</script>

<style lang="scss" scoped>
.main-layout {
  display: flex;
  flex-direction: column;

  .main-layout-center {
    max-height: 100%;
    overflow: hidden;

    :deep(> *) {
      height: 100% !important;
      max-height: 100% !important;
    }
  }

  .main-layout-top,
  .main-layout-bottom {
    flex: 0 0 auto;
  }
}
</style>
